import {CartRowService, CartService, SetCartResponseDto, SetCartRowDto, SetCartRowResponseDto,} from "../../api";
import {createContext, useContext, useEffect, useState} from "react";
import {toIncludes} from "../request";

// @ts-ignore
export const CartContext = createContext<{
  userCart: SetCartResponseDto | undefined,
  removeItemFromCart: (id: number) => Promise<any>,
  addItemToCart: (qty: number,
                  variantId: number) => Promise<any>,
  setCart: (rows: SetCartRowDto[]) => Promise<SetCartRowResponseDto[]>
}>()

export const useCart = () => {
  return useContext(CartContext);
};

export const CartProvider = ({children}: { children: any }) => {
  const [userCart, setUserCart] = useState<SetCartResponseDto | undefined>();
  const load = () => {
    CartService.findOneCartController(0, undefined, toIncludes({
      rows: {
        variant: {product: {brand: true, media: true}, media: true},
      }
    })).then(d => {
      setUserCart(d.data)
    })
  }

  const removeItemFromCart = async (id: number) => {
    return await CartRowService.deleteCartRowController(id).then((res: any) => {
      if (res) {
        load()
        return res
      }
    });
  };

  const addItemToCart = async (
    qty: number,
    variantId: number
  ) => {
    try {
      const response = await CartRowService.createCartRowController({
        qty: qty,
        variant: variantId,
      });
      return response.data;
    } catch (error) {
      return error;
    }
  };

  const setCart = async (rows: SetCartRowDto[]): Promise<SetCartRowResponseDto[]> => {
    const response = await CartService.setCartController({
      rows
    });

    setUserCart(response);
    const load = () => {
      CartService.findOneCartController(0, undefined, toIncludes({
        rows: {
          variant: {product: {brand: true, media: true}, media: true},
        }
      })).then(d => {
        setUserCart(d.data)
      })
    }
    load()
    return response.rows;
  }


  useEffect(() => {
    load()
  }, [])

  return (
    <CartContext.Provider
      value={{userCart, removeItemFromCart, addItemToCart, setCart}}
    >
      {children}
    </CartContext.Provider>
  );
}
